(() => {
  if (customElements.get('rich-accordions')) return;

  class RichAccordions extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      document.addEventListener('click', event => this.handleAnchorClick(event), {
        signal: this.abortController.signal,
      });
      window.addEventListener('hashchange', () => this.openHashTarget(), {
        signal: this.abortController.signal,
      });

      requestAnimationFrame(() => this.openHashTarget());
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.anchorController?.abort();
      clearTimeout(this.anchorTimer);
    }

    handleAnchorClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const target = this.getDetailsTarget(link.hash);
      if (!target) return;

      event.preventDefault();
      history.pushState(null, '', link.hash);
      this.openDetailsTarget(target, true);
    }

    openHashTarget() {
      const target = this.getDetailsTarget(window.location.hash);
      if (target) this.openDetailsTarget(target, false);
    }

    getDetailsTarget(hash) {
      if (!hash || hash === '#') return null;

      let targetId;
      try {
        targetId = decodeURIComponent(hash.slice(1));
      } catch (error) {
        return null;
      }

      const target = document.getElementById(targetId);
      if (!target || !this.contains(target) || !target.matches('details.rich-accordions__section')) {
        return null;
      }

      return target;
    }

    openDetailsTarget(target, moveFocus) {
      const summary = target.querySelector(':scope > summary');
      const body = summary?.nextElementSibling;
      if (!summary || !body) return;

      this.anchorController?.abort();
      clearTimeout(this.anchorTimer);
      this.anchorController = new AbortController();

      let isSettled = false;
      const settle = () => {
        if (isSettled || !this.isConnected) return;
        isSettled = true;
        clearTimeout(this.anchorTimer);
        this.anchorController.abort();
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (moveFocus) summary.focus({ preventScroll: true });
      };

      if (target.open && target.classList.contains('is-active')) {
        settle();
        return;
      }

      body.addEventListener(
        'transitionend',
        event => {
          if (event.target === body && event.propertyName === 'height') settle();
        },
        { signal: this.anchorController.signal }
      );

      summary.click();
      this.anchorTimer = setTimeout(settle, 500);
    }
  }

  customElements.define('rich-accordions', RichAccordions);
})();
